<template>
<div>
    <Header></Header>
<div class="d-flex flex-column justify-content-start align-items-center page-div">  
    
        <div v-if="!schedulingAppointment && !scheduled">
            <!--div ng-if="appointment"-->
            <div>
                <h3 class="text-left full-header">Your appointment will be scheduled for {{ scheduledTime }} on {{ scheduledDate }}. You will need to head to the {{ locationString }} location at your scheduled time.</h3>
                
                <h3 class="text-left full-header">By scheduling this appointment, you are acknowledging that you have not been exposed to or are currently expressing symptoms of COVID-19 (coronavirus).</h3>
            </div>

            <div class="d-flex flex-column justify-content-center align-items-center" style="margin-top:30px;margin-bottom:30px">
                <b-button variant="primary" @click="scheduleAppointment()" class="button-style" style="margin-bottom:10px">
                    <span class="btn-text">Schedule My Appointment</span>
                </b-button>
                <b-button variant="outline-primary" @click="goBack()" class="button-style" style="margin-bottom:10px">
                    <span class="btn-text">Back</span>
                </b-button>
                <b-button variant="outline-primary" href="https://siucu.org/" class="button-style" style="margin-bottom:10px;padding-top:10px">
                    <span class="btn-text">Cancel</span>
                </b-button>
                
            </div>
        </div>
        <div class="d-flex flex-column align-items-center align-content-center justify-content-center" style="margin-top:20px" v-if="schedulingAppointment">            
            <h3>Please wait while we schedule your appointment</h3>
            <br>            
            <img src="@/assets/img-siu/loading.gif" style="height:100px"/>                                      
        </div>
        <div v-if="!schedulingAppointment && scheduled">
            <!--div ng-if="appointment"-->
            <div style="margin-top:30px">
                <h3 class="text-left" style="margin-bottom:20px;line-height:1.5; max-width:65vw">Your appointment has been confirmed for {{ scheduledTime }} on {{ scheduledDate }}. Please head to the {{ locationString }} location at your scheduled time.</h3>                
            </div>
        </div>
    </div>
    <b-modal ref="cannotFindModalRef" header-bg-variant="dark" header-text-variant="light" body-bg-variant="dark" footer-bg-variant="dark" body-text-variant="light" footer-text-variant="light" :ycentered=true centered :ok-only="true" title="Unable to Schedule">
        We could not locate you in our system. Please call our contact center for assistance in making your appointment.
        <div slot="modal-footer">
            <b-button variant="primary" pill class="modal-btn" @click="dismissCannotFindModal()">OK</b-button>
        </div>
    </b-modal>            
    <b-modal ref="duplicateModalRef" header-bg-variant="dark" header-text-variant="light" body-bg-variant="dark" footer-bg-variant="dark" body-text-variant="light" footer-text-variant="light" :ycentered=true centered :ok-only="true" title="Unable to Schedule">
        You already have an appointment scheduled for this time. Please call our contact center for assistance if you believe this is in error.
        <div slot="modal-footer">
            <b-button variant="primary" pill class="modal-btn" @click="dismissDuplicateModal()">OK</b-button>
        </div>
    </b-modal>            
    <b-modal ref="errorModalRef" header-bg-variant="dark" header-text-variant="light" body-bg-variant="dark" footer-bg-variant="dark" body-text-variant="light" footer-text-variant="light" :ycentered=true centered :ok-only="true" title="Unable to Schedule">
        We are sorry, we were unable to schedule your appointment. Please call our contact center for assistance in making your appointment.
        <div slot="modal-footer">
            <b-button variant="primary" pill class="modal-btn" @click="dismissErrorModal()">OK</b-button>
        </div>    
    </b-modal>       
    <b-modal ref="noMoreAppointmentsRef" header-bg-variant="dark" header-text-variant="light" body-bg-variant="dark" footer-bg-variant="dark" body-text-variant="light" footer-text-variant="light" :ycentered=true centered :ok-only="true" title="Unable to Schedule">
        We are sorry, that time is no longer available. Please select another time and try again.
        <div slot="modal-footer">
            <b-button variant="primary" pill class="modal-btn" @click="dismissNoMoreModal()">OK</b-button>
        </div>    
    </b-modal>       
</div>     
</template>
<script>
import { mapState } from "vuex"
import moment from 'moment';
import Header from '@/components/Header'

export default {
    name: 'ConfirmAppointment',
    components: {
        Header
    },
    data: function() {
        return {
            scheduled: false,
        }
    },
    methods: {
        async scheduleAppointment() {            
            let appt = await this.$store.dispatch('scheduleAppointment');

            if(appt.id) {
                if(appt.id === -1) {
                    this.$refs.noMoreAppointmentsRef.show();
                } else {
                    this.scheduled = true;
                }
            } else {
                if(appt.paymentToken === 'Duplicate') {
                    this.$refs.duplicateModalRef.show();    
                } else if(appt.paymentToken === 'Cannot Find') {
                    this.$refs.cannotFindModalRef.show();
                } else {
                    this.$refs.errorModalRef.show();
                }
                
            }
        },
        goBack() {
            this.$router.push('/');
        },
        dismissCannotFindModal() {
            this.$refs.cannotFindModalRef.hide();
        },
        dismissDuplicateModal() {
            this.$refs.duplicateModalRef.hide();
        },
        dismissErrorModal() {
            this.$refs.errorModalRef.hide();
        },
        dismissNoMoreModal() {
            this.$refs.noMoreAppointmentsRef.hide();
        }

    },
    computed: {
        ...mapState({                     
            appointmentType: state => state.appointmentType,
            locationString: state => state.locationString,
            schedulingAppointment: state => state.schedulingAppointment,
        }),
        scheduledDate: function() {
            return moment(this.$store.state.appointmentDate).format("MM/DD/YYYY");
        },
        scheduledTime: function() {
            return this.$store.state.appointmentTime;
        }
    }
}
</script>
